import React from 'react';
import './Button.scss';

export default function Button({ children, type, className, onClick, href, onMouseEnter, onMouseLeave, ...rest }) {
    const classes = `btn ${className}` + (type ? ` ${type}` : '');

    return href ? (
        <a href={href} className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} {...rest}>
            {children}
        </a>
    ) : (
        <button className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} {...rest}>
            {children}
        </button>
    );
}
